import { render, staticRenderFns } from "./SpecLump.vue?vue&type=template&id=39ceaa49&scoped=true&"
import script from "./SpecLump.vue?vue&type=script&lang=js&"
export * from "./SpecLump.vue?vue&type=script&lang=js&"
import style0 from "./SpecLump.vue?vue&type=style&index=0&id=39ceaa49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ceaa49",
  null
  
)

export default component.exports